import React, { useEffect, useRef } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperType } from 'swiper';

import 'swiper/css';
import 'swiper/css/pagination';

import { IconButton } from '@/shared/ui/Button/IconButton';

import Up from '@/assets/icons/upArrow.svg?react';
import Down from '@/assets/icons/downArrow.svg?react';
import { cn } from '@/shared/lib/utils';
import { KnowledgeMiniCard } from '@/shared/ui/Card/KnowledgeMiniCard';
import { propertyType } from '@/entities/home_content/model/types';
import { buildingType } from '@/entities/knowledge/model/types';
import { NavLink } from 'react-router-dom';

interface IVerticalSliderProps {
  slides: buildingType[];
  // onChange: (building: buildingType) => void;
  className?: string;
}

export function VerticalSlider({
  slides,
  className,
  // onChange,
}: IVerticalSliderProps) {
  const swiperRef = useRef<SwiperType | null>(null);

  const handleSwiperNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };

  const handleSwiperPrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };

  // useEffect(() => {
  //   const handleSlideChange = () => {
  //     if (swiperRef.current && slides.length > 0) {
  //       const realIndex = swiperRef.current.realIndex;
  //       onChange(slides[realIndex]);
  //     }
  //   };

  //   if (swiperRef.current) {
  //     swiperRef.current.on('slideChange', handleSlideChange);

  //     if (slides.length > 0) {
  //       const realIndex = swiperRef.current.realIndex;
  //       onChange(slides[realIndex]);
  //     }
  //   }

  //   return () => {
  //     if (swiperRef.current) {
  //       swiperRef.current.off('slideChange', handleSlideChange);
  //     }
  //   };
  // }, [slides, onChange]);

  return (
    <div
      className={cn(
        'relative mx-auto h-fit w-full max-w-[581px] overflow-hidden',
        className
      )}
    >
      <div className="absolute right-[13px] top-1/2 z-10 flex -translate-y-1/2 flex-col gap-[10px] md:right-[19px] md:gap-[24px]">
        <IconButton
          className="blur-cls h-[36px] w-[36px]"
          icon={<Up />}
          onClick={handleSwiperPrev}
        />
        <IconButton
          className="blur-cls h-[36px] w-[36px]"
          icon={<Down />}
          onClick={handleSwiperNext}
        />
      </div>

      <Swiper
        loop={true}
        direction="vertical"
        pagination={{ clickable: true }}
        className="mySwiper h-[176px] rounded-[20px] md:h-[264px]"
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
        }}
      >
        {slides.map((item, index) => (
          <SwiperSlide key={index} id={item.id?.toString()}>
            <NavLink to={`/buildings/${item.id}`}>
              <KnowledgeMiniCard knowlendge={item} />
            </NavLink>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
